var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 25C2.2475 25 1.51797 24.6943 0.9114 24.0828C0.304833 23.4714 0.00103333 22.7354 0 21.875V3.125C0 2.26562 0.3038 1.53021 0.9114 0.91875C1.519 0.307291 2.24853 0.00104167 3.1 0H27.9C28.7525 0 29.4825 0.30625 30.0901 0.91875C30.6977 1.53125 31.001 2.26667 31 3.125V21.875C31 22.7344 30.6967 23.4703 30.0901 24.0828C29.4836 24.6953 28.7535 25.001 27.9 25H3.1ZM15.5 14.0625L3.1 6.25V21.875H27.9V6.25L15.5 14.0625ZM15.5 10.9375L27.9 3.125H3.1L15.5 10.9375ZM3.1 6.25V3.125V21.875V6.25Z",
    fill: "#434790"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.75d5f12d1bac8160e4f011cbccf13e71.svg";
export { ForwardRef as ReactComponent };